import { courseChatTitle, courseLanguageFlagUrl } from '../utils/courseDisplay';

export function ChatHeaderTitle({ course }) {
    const title = courseChatTitle(course);
    const flagUrl = courseLanguageFlagUrl(course);
    const languageName = course?.language?.name?.trim();

    return (
        <div className="chat-header__title-wrap">
            {flagUrl && (
                <img
                    src={flagUrl}
                    alt={languageName ? `Bandera ${languageName}` : 'Bandera del idioma'}
                    className="chat-header__flag"
                />
            )}
            <h2 className="chat-header__title" title={title}>
                {title}
            </h2>
        </div>
    );
}
